import script from "./sw-item-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor.vue?vue&type=style&index=0&id=0f33d290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f33d290"]])

export default __exports__